import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerIntegrationsPage from "../pages/DsokCustomerIntegrationsPage";

export const dsokCustomerIntegrationsRoute = {
  path: "/dsok/customer-detail/:customerUrl/integrations",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerIntegrationsPage} />
    </DsokCustomerDetailProvider>
  ),
};
